<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات نقش"
        >
          <b-form
            ref="userpermissionform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="4">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>

                  </b-col>
                  <b-col md="8">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-input
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <app-timeline>
                      <app-timeline-item
                        v-for="item in items"
                        :key="item.Key"
                        :variant="enums('UserPermissionIcon', 'key', item.Key, 'color')"
                        :icon="enums('UserPermissionIcon', 'key', item.Key, 'icon')"
                      >
                        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                          <h6 class="mb-2">
                            {{ item.Title }}
                          </h6>
                          <small class="text-muted">دسترسی های مدیریت {{ item.Title }}</small>
                        </div>
                        <b-row>
                          <b-col
                            v-for="permission in item.Items"
                            :key="permission.Id"
                            md="6"
                            class="mb-1 label-color"
                          >
                            <b-form-checkbox
                              v-model="permission.Key"
                              value="true"
                              class="custom-control-primary"
                            >
                              {{ permission.Title }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                      </app-timeline-item>
                    </app-timeline>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import {
  BForm, BButton, BCard, BOverlay, BFormCheckbox, BFormGroup, BFormInput,
} from 'bootstrap-vue'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  name: 'UserRoleDetails',
  components: {
    BForm,
    BButton,
    BCard,
    BOverlay,
    AppTimeline,
    AppTimelineItem,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      items: [],
      Form: {
        Id: null,
        Title: null,
        Description: null,
        UserPermissionIds: [],
        Ar: false,
        En: false,
        Fa: false,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.getUserPermission()
    }
  },
  methods: {
    save() {
      let url = this.$api.userrole.add
      if (this.$route.params.id) {
        url = this.$api.userrole.update
      }

      this.Form.UserPermissionIds = []

      this.items.forEach(item => {
        item.Items.forEach(permission => {
          if (permission.Key === 'true') {
            this.Form.UserPermissionIds.push(permission.Id)
          }
        })
      })

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        }).finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.userrole.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          this.getUserPermission()
        })
    },
    getUserPermission() {
      this.loading = true
      this.$http.post(
        this.$api.userpermission.getall, {},
      )
        .then(res => {
          this.loading = false
          this.items = res.data

          if (this.Form.Id) {
            this.items.forEach(item => {
              item.Items.forEach(permission => {
                if (this.Form.UserPermissionIds.includes(permission.Id)) {
                  this.$set(permission, 'Key', 'true')
                }
              })
            })
          }
        })
    },
  },
}
</script>
<style>
.label-color .custom-control-label {
  color: #6e6b7b;
}
</style>
